"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
function VideoTrack(_a) {
    var thumbnail = _a.thumbnail, videoLength = _a.videoLength, trimEnd = _a.trimEnd, trimStart = _a.trimStart, setTrimStart = _a.setTrimStart, setTrimEnd = _a.setTrimEnd;
    var untrimmed = react_1.useRef();
    var trimmed = react_1.useRef();
    var editor = react_1.useRef();
    var BORDER_SIZE = 16;
    var _b = react_1.useState(null), trimming = _b[0], setTrimming = _b[1];
    var _c = react_1.useState(null), mPos = _c[0], setMPos = _c[1];
    var _d = react_1.useState(null), resize = _d[0], setResize = _d[1];
    var findTrim = function (trimPosition, w, setTrim) {
        var position = (trimPosition / w) * 100;
        setTimeout(function () {
            if (trimming === 'l') {
                setTrim((videoLength / 100) * position);
            }
            else {
                setTrim(videoLength - ((videoLength / 100) * position));
            }
        }, 100);
    };
    var drop = function (event) {
        setResize(false);
        var w = parseInt(getComputedStyle(editor.current).width);
        if (trimming === 'l') {
            findTrim(trimStart, w, setTrimStart);
            if (trimEnd === 0) {
                setTrimEnd(videoLength);
            }
        }
        if (trimming === 'r') {
            findTrim(trimEnd, w, setTrimEnd);
        }
    };
    react_1.useEffect(function () {
        if (!resize) {
            return;
        }
        var resizeVideo = function (event) {
            var dx = mPos - event.x;
            setMPos(event.x);
            var styles = getComputedStyle(untrimmed.current);
            var w = parseInt(getComputedStyle(editor.current).width);
            var pl = (((parseInt(styles.paddingLeft) - dx) / w) * 100).toFixed(2) + '%';
            var pr = (((parseInt(styles.paddingRight) + dx) / w) * 100).toFixed(2) + '%';
            if (trimming === 'l') {
                untrimmed.current.style.paddingLeft = pl;
                setTrimStart(parseInt(styles.paddingLeft) - dx);
            }
            if (trimming === 'r') {
                untrimmed.current.style.paddingRight = pr;
                setTrimEnd(parseInt(styles.paddingRight) + dx);
            }
        };
        editor.current.addEventListener('mousemove', resizeVideo);
        return function () { return editor.current.removeEventListener('mousemove', resizeVideo); };
    }, [resize, mPos]);
    var drag = function (event) {
        if (event.nativeEvent.offsetX < BORDER_SIZE) {
            setMPos(event.nativeEvent.x);
            setTrimming('l');
            setResize(true);
            jwplayer().play();
        }
        if (event.nativeEvent.offsetX > (trimmed.current.clientWidth) - 2 * BORDER_SIZE) {
            setMPos(event.nativeEvent.x);
            setTrimming('r');
            setResize(true);
            jwplayer().play();
        }
    };
    return react_1.default.createElement("div", { className: 'storybook-timelines-video-track-editor', ref: editor },
        react_1.default.createElement("div", { className: 'storybook-timelines-video-track-wrapper' },
            react_1.default.createElement("div", { className: "storybook-timelines-track-content", ref: untrimmed },
                react_1.default.createElement("div", { className: 'storybook-timelines-video-track', ref: trimmed, onMouseDown: drag, onMouseUp: drop },
                    react_1.default.createElement("div", { className: 'w-24 flex-shrink-0 cursor-default' },
                        react_1.default.createElement("div", { className: 'storybook-thumb-wrapper rounded w-full' },
                            react_1.default.createElement("img", { src: thumbnail, alt: '', className: 'absolute h-full w-full object-cover' })))))));
}
exports.default = VideoTrack;
// let seekTo = Math.floor((parseInt(pointer.current.style.left) / parseInt(getComputedStyle(editor.current, '').width)) * d)
